import { render, staticRenderFns } from "./invoice-history-details-product-table.vue?vue&type=template&id=56b32dae&"
import script from "./invoice-history-details-product-table.vue?vue&type=script&lang=js&"
export * from "./invoice-history-details-product-table.vue?vue&type=script&lang=js&"
import style0 from "./invoice-history-details-product-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports